export default "__VITE_ASSET__6782ab98__"